// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDDDWxfXl9OxWSC-tpfO1cslYGiX9pMM60",
    authDomain: "cigar-gansters.firebaseapp.com",
    projectId: "cigar-gansters",
    storageBucket: "cigar-gansters.appspot.com",
    messagingSenderId: "929944621279",
    appId: "1:929944621279:web:84d397c8e36edcef8ad96a",
    measurementId: "G-SB2L40BQXT"
};

// Initialize Firebase

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
